module.exports = __webpack_public_path__ + "img/photo-wj.ff9846fa.png";